import { ApiProvider } from 'providers/request'
import { EmailNotificationsFields } from 'features/Account/components/EmailNotificationsForm/EmailNotificationsForm'
import { User, UserFilters, UserParams, ChangePasswordFields } from 'models/user'
import { UserFormFields } from 'features/Organization/components/UserForm/UserForm'
import { UserPermissions, UserPermissionsUpdateParams } from 'models/user-permissions'
import { UrlUtils } from 'utils/url'

export const UserRepository = {
  async fetchAll(filters?: UserFilters): Promise<User[]> {
    const queryParams = UrlUtils.formatQueryParams(filters)
    const result = await ApiProvider.get(`/users?${queryParams}`)
    return result.map((user: UserParams) => new User(user))
  },

  fetch(id: string): Promise<User> {
    return ApiProvider.get(`/users/${id}`).then((user) => new User(user))
  },

  create(data: UserFormFields): Promise<any> {
    return ApiProvider.post(`/users`, data)
  },

  update(userId: string, data: Partial<User>): Promise<User> {
    return ApiProvider.patch(`/users/${userId}`, data)
  },

  updateCurrentUser(data: Partial<User>): Promise<any> {
    return ApiProvider.patch(`/me`, data)
  },

  delete(userId: string): Promise<void> {
    return ApiProvider.delete(`/users/${userId}`)
  },

  resetPassword(data: ChangePasswordFields): Promise<void> {
    return ApiProvider.post('/password/change', data)
  },

  updateNotificationPreferences(data: EmailNotificationsFields): Promise<void> {
    return ApiProvider.patch('/notification-preferences', data)
  },

  // -- Permissions
  fetchPermissions(userId: string): Promise<UserPermissions> {
    return ApiProvider.get(`/users/${userId}/permissions`)
  },

  updatePermissions(userId: string, permissions: UserPermissionsUpdateParams): Promise<User> {
    return ApiProvider.patch(`/users/${userId}/permissions`, permissions)
  },
}
